import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Observable, map, startWith } from 'rxjs';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'edt-autocomplete',
  standalone: true,
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
  ],
})
export class AutocompleteComponent<T extends { [key: string]: unknown }>
  implements OnInit
{
  @Input({ required: true }) labelName = 'Label';
  @Input({ required: true }) placeHolder = 'Placehoder';
  @Input({ required: true }) options: T[] = [];
  @Input({ required: true }) field = 'name';
  @Input() controlData: T | null = null;
  @Output() valueChange: EventEmitter<T | null> = new EventEmitter();

  filteredOptions!: Observable<T[]>;
  control: FormControl = new FormControl<T | null>(null);

  ngOnInit() {
    this._observeControlChanges();
  }

  displayFn(elem: T): string {
    return elem && elem[this.field] ? String(elem[this.field]) : '';
  }

  private _observeControlChanges(): void {
    this.filteredOptions = this.control.valueChanges.pipe(
      startWith(''),
      map((value) => {
        const name = typeof value === 'string' ? value : value?.name;
        return name ? this._filter(name as string) : this.options.slice();
      })
    );
  }

  private _filter(name: string): T[] {
    const filterValue = name.toLowerCase();

    return this.options.filter((option) =>
      String(option[this.field]).toLowerCase().includes(filterValue)
    );
  }
}
